import React, { ChangeEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { COND_KEY_SET, CondKey, useSearchConds } from '../../hooks/useSearchConds';

const SearchConds = () => {
  const { setCond, stringifyParams } = useSearchConds();
  const navigate = useNavigate();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const condKey: string = e.target.name || "";

    if (e.target.checked) {
      setCond(condKey, e.target.value);
    } else {
      setCond(condKey, e.target.value, false);
    }
  }

  const condItems = (condKey: CondKey) => {
    return Object.keys(COND_KEY_SET[condKey]).map((key, idx) => {
      return (
        <span className={ `wpcf7-list-item ${ idx === 0 ? 'first' : '' }` } key={ key } >
          <label>
            <input
              type="checkbox"
              name={ condKey }
              value={ key }
              onChange={ handleChange }
            />
            <span className="wpcf7-list-item-label">{ COND_KEY_SET[condKey][key] }</span>
          </label>
        </span>
      )
    })
  }

  const handleSubmit = () => {
    navigate(`/search-result?${ stringifyParams() }`);
  }

  return (
      <section className="search_conds">
        <h2 className="main_title"><span>こだわり条件からドナーを探す</span></h2>
        <div className="form">
          <dl className="graf_list">
            <dt>本人確認</dt>
            <dd className="flex">
              <span className="wpcf7-form-control-wrap checkbox-content">
                <span className="wpcf7-form-control wpcf7-checkbox wpcf7-validates-as-required">
                  { condItems('kyc_certified_only') }
                </span>
              </span>
            </dd>
            <dt>エリア</dt>
            <dd className="flex">
              <span className="wpcf7-form-control-wrap checkbox-content">
                <span className="wpcf7-form-control wpcf7-checkbox wpcf7-validates-as-required">
                  { condItems('area') }
                </span>
              </span>
            </dd>
            <dt>年齢</dt>
            <dd className="flex">
              <span className="wpcf7-form-control-wrap checkbox-content">
                <span className="wpcf7-form-control wpcf7-checkbox wpcf7-validates-as-required">
                  { condItems('age') }
                </span>
              </span>
            </dd>
            <dt>血液型</dt>
            <dd className="flex">
              <span className="wpcf7-form-control-wrap checkbox-content">
                <span className="wpcf7-form-control wpcf7-checkbox wpcf7-validates-as-required">
                  { condItems('blood_type') }
                </span>
              </span>
            </dd>
            <dt>身長</dt>
            <dd className="flex">
              <span className="wpcf7-form-control-wrap checkbox-content">
                <span className="wpcf7-form-control wpcf7-checkbox wpcf7-validates-as-required">
                  { condItems('height') }
                </span>
              </span>
            </dd>
            <dt>体型</dt>
            <dd className="flex">
              <span className="wpcf7-form-control-wrap checkbox-content">
                <span className="wpcf7-form-control wpcf7-checkbox wpcf7-validates-as-required">
                  { condItems('body_figure') }
                </span>
              </span>
            </dd>
            <dt>最終学歴</dt>
            <dd className="flex">
              <span className="wpcf7-form-control-wrap checkbox-content">
                <span className="wpcf7-form-control wpcf7-checkbox wpcf7-validates-as-required">
                  { condItems('college_type') }
                </span>
              </span>
            </dd>
            <dt>理系・文系</dt>
            <dd className="flex">
              <span className="wpcf7-form-control-wrap checkbox-content">
                <span className="wpcf7-form-control wpcf7-checkbox wpcf7-validates-as-required">
                  { condItems('major_type') }
                </span>
              </span>
            </dd>
            <dt>婚姻歴</dt>
            <dd className="flex">
              <span className="wpcf7-form-control-wrap checkbox-content">
                <span className="wpcf7-form-control wpcf7-checkbox wpcf7-validates-as-required">
                  { condItems('marriage') }
                </span>
              </span>
            </dd>
            <dt>子供</dt>
            <dd className="flex">
              <span className="wpcf7-form-control-wrap checkbox-content">
                <span className="wpcf7-form-control wpcf7-checkbox wpcf7-validates-as-required">
                  { condItems('children') }
                </span>
              </span>
            </dd>
            <dt>性病検査</dt>
            <dd className="flex">
              <span className="wpcf7-form-control-wrap checkbox-content">
                <span className="wpcf7-form-control wpcf7-checkbox wpcf7-validates-as-required">
                  { condItems('std_certified_only') }
                </span>
              </span>
            </dd>
            <dt>精子品質</dt>
            <dd className="flex">
              <span className="wpcf7-form-control-wrap checkbox-content">
                <span className="wpcf7-form-control wpcf7-checkbox wpcf7-validates-as-required">
                  { condItems('semen_total') }
                </span>
              </span>
            </dd>
            <dt>提供方法</dt>
            <dd className="flex">
              <span className="wpcf7-form-control-wrap checkbox-content">
                <span className="wpcf7-form-control wpcf7-checkbox wpcf7-validates-as-required">
                  { condItems('methods') }
                </span>
              </span>
            </dd>
            <dt>謝礼金</dt>
            <dd className="flex">
              <span className="wpcf7-form-control-wrap checkbox-content">
                <span className="wpcf7-form-control wpcf7-checkbox wpcf7-validates-as-required">
                  { condItems('gratuity') }
                </span>
              </span>
            </dd>
          </dl>
          <input type="submit" value="こだわり検索" className="orangebtn searchbtn" onClick={ handleSubmit }/>
        </div>
      </section>
  );
}

export default SearchConds;
